import { Button, Header as HeaderLayout, Link } from "@endya-conformite/ui-kit";
import QuestionCircle from "@endya-conformite/ui-kit/src/assets/icons/question-circle.svg?react";
import Logo from "@endya-conformite/ui-kit/src/assets/logo.png";
import style from "./Header.module.scss";

export type HeaderProps = { title?: string };
export function Header({ title }: HeaderProps) {
  return (
    <HeaderLayout
      left={
        <>
          <img className={style.logo} src={Logo} alt="endya logo" />
          {title && <h2>{title}</h2>}
        </>
      }
      right={
        <Link to="https://www.endya.fr/contact-support-endya/" target="_blank">
          <Button variant="text" icon={<QuestionCircle />}>
            Besoin d&apos;aide
          </Button>
        </Link>
      }
    />
  );
}
